import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReactPlayer from "react-player";

import IconLogoC from "../../components/icons/logoC";
import { fixExternalLinks } from "../../utils/helper";

class Mission extends Component {
    _renderSection(section, video) {
        return (
            <div key={section.key}>
                <div className="flex">
                    <div className="xl:w-4/12" />
                    <div className="xl:w-8/12">
                        <h1 className="font-judge font-bold text-17 xl:text-30 text-pink mb-30 xl:mb-40">
                            {section.attributes.title}
                        </h1>
                        <p className="font-bold text-30 xl:text-60 text-pink">
                            {section.attributes.subtitle}
                        </p>
                    </div>
                </div>
                <div className="xl:flex xl:mt-40 mb-50 xl:mb-120">
                    <div className="xl:w-2/12" />
                    <div className="xl:w-2/12 w-1/2 pt-50 pb-50 xl:pb-0 xl:pt-70">
                        <IconLogoC className="w-full h-auto" />
                    </div>
                    <div className="xl:w-2/12" />
                    <div
                        className="article-body leading-tight text-17 xl:text-23 text-pink xl:w-6/12"
                        dangerouslySetInnerHTML={{
                            __html: fixExternalLinks(section.attributes.body),
                        }}
                    />
                </div>
                {video && (
                    <div className="flex justify-center w-full xl:w-7/12 mx-auto">
                        <div className="aspect-ratio-16/9 w-full relative">
                            <div className="absolute w-full h-full">
                                <ReactPlayer
                                    width="100%"
                                    height="100%"
                                    controls
                                    url={video}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    render() {
        const { infoData } = this.props;

        if (!infoData) return null;

        return (
            <div className="bg-blue pt-40 xl:pt-100 pb-50 xl:pb-150 px-16 xl:px-50">
                {infoData.content.map((section) =>
                    this._renderSection(section, infoData.embed)
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    infoData: state.pages.info,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Mission);
